exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list-item--active {\n  color: white !important;\n}\n", ""]);

// exports
